export default __webpack_public_path__ + "static/Pattern6-afa3a10e25e32199c3744ac1878b0efe.png";